import * as d3 from 'd3'
import L from 'leaflet'

// export function createDeviceIcon(device) {
//   // console.log(device)
//   const displayValue = device.name || device.tag || device.id
//   const ibValue = displayValue
//   const unit = ''
//   const zoom = 12
//   let multiplier = 1
//   if (zoom <= 3) multiplier = 0.35
//   else if (zoom <= 7) multiplier = 0.6
//   else if (zoom <= 11) multiplier = 0.75

//   function getWidthOfText(txt, font, fontSize) {
//     if (typeof document !== "undefined") {
//       const canvas = document.createElement("canvas");
//       const context = canvas.getContext("2d");
//       context.font = `${fontSize} ${font}`;
//       return context.measureText(txt).width;
//     }
//     return 50;
//   }

//   const col = device.entityType?.color || "#0075C9"
//   const colFont = "white";
//   const fontsize = Math.max(Math.round(15 * multiplier), 8);
//   const fontsize2 = Math.max(Math.round(12 * multiplier), 8);
//   const height = Math.round(30 * multiplier);
//   let longitud =
//     Math.round(
//       getWidthOfText(
//         " " + String(ibValue) + (unit !== "" ? " " + unit : ""),
//         "Manrope",
//         fontsize + "px"
//       )
//     ) + 20
//   let left;
//   if (longitud < 60) {
//     longitud = 60;
//     left = 26;
//   } else {
//     left = longitud / 2 - 4;
//   }

//   const unitHtml = unit !== "" ? "&nbsp;" + unit : "";

//   const htmlSource =
//     "<div style='width: " + longitud + "px; height: " + height + "px;'>"
//     + "<div class='rectangle' style='background:" + col + "; color: " + colFont + "; font-size: " + fontsize + "px;margin-top: " + String(Math.round(-(height - 12) / 2)) + "px;border-radius: 9px 10px 10px 9px;height:" + height + "px; width:" + longitud + "px;overflow:hiden;padding:" + String(Math.round(3 * (height / 30))) + "px;padding-right:" + String(Math.round(7 * (height / 30))) + "px;justify-content: center; display:flex; align-items:center; '>" + "&nbsp;" + ibValue.toString() + "<span style='font-size: " + fontsize2 + "px;'>" + unitHtml + "</span></div>"
//     + "<div class='triangle-left' style='float:left;left: " + left + "px;'></div>"
//     + "</div>";

//   let iconAnchorArray = longitud === 60 ? [30, 32] : [longitud / 2, 32];

//   return new window.L.DivIcon({
//     html: htmlSource,
//     iconSize: [longitud, 30],
//     iconAnchor: iconAnchorArray,
//     popupAnchor: [0, -38]
//   });
// }

export function createDeviceIcon(device) {
  const text = device.name || device.tag || device.id;
  const col = device.entityType?.color || "#0075C9";

  const html = `
    <div class="device-marker">
      <div class="device-label" style="background:${col}">
        ${text}
      </div>
      <div class="triangle"></div>
    </div>
  `;

  return new window.L.DivIcon({
    html,
    className: '',
    iconSize: null,
    iconAnchor: [0, 0],
    popupAnchor: [0, -35]
  });
}

// export function createComplaintIcon() {
//   return new L.DivIcon({
//     html: `<div style="
//       width:18px;
//       height:18px;
//       background:#E53935;
//       border:3px solid white;
//       border-radius:50%;
//       box-shadow:0 0 6px 2px rgba(0,0,0,0.25);
//       "></div>`,
//     className: "",
//     iconSize: [18, 18],
//     iconAnchor: [9, 9]
//   });
// }

export function createComplaintIcon(status = 0) {
  const color = getIconColorByStatus(status); // verde si status = 1, rojo si 0
  return new L.DivIcon({
    html: `<div style="
      width:18px;
      height:18px;
      background:${color};
      border:3px solid white;
      border-radius:50%;
      box-shadow:0 0 6px 2px rgba(0,0,0,0.25);
      "></div>`,
    className: "",
    iconSize: [18, 18],
    iconAnchor: [9, 9]
  });
}

export function createComplaintClusterIcon(cluster) {
  const color = getClusterColorByChildren(cluster);
  return L.divIcon({
    html: `<div style="
      background:${color};
      color:white;
      border-radius:50%;
      width:32px;
      height:32px;
      display:flex;
      align-items:center;
      justify-content:center;
      border: 2px solid white;
      font-weight: bold;
      box-shadow:0 0 8px 2px rgba(0,0,0,0.2);
      font-size:16px;">
        ${cluster.getChildCount()}
      </div>`,
    className: "",
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });
}

export function createIncidentIcon(status = 0) {
  const color = getIconColorByStatus(status); // verde si status = 1, rojo si 0
  return new L.DivIcon({
    html: `<div style="
      width:18px;
      height:18px;
      background:${color};
      border:3px solid white;
      transform: rotate(45deg);
      box-shadow:0 0 6px 2px rgba(0,0,0,0.25);
      "></div>`,
    className: "",
    iconSize: [18, 18],
    iconAnchor: [9, 9]
  });
}

export function createIncidentClusterIcon(cluster) {
  const color = getClusterColorByChildren(cluster);
  return L.divIcon({
    html: `<div style="
      background:${color};
      color:white;
      transform: rotate(45deg);
      width:32px;
      height:32px;
      display:flex;
      align-items:center;
      justify-content:center;
      border: 2px solid white;
      font-weight: bold;
      box-shadow:0 0 8px 2px rgba(0,0,0,0.2);
      font-size:16px;">
        <div style="transform: rotate(-45deg);">
          ${cluster.getChildCount()}
        </div>
      </div>`,
    className: "",
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });
}

function getIconColorByStatus(status) {
  return status === 1 ? '#52c41a' : '#faad14'; 
}

function getClusterColorByChildren(cluster) {
  const markers = cluster.getAllChildMarkers();

  const hasStatus0 = markers.some(
    m => m.options.status === 0
  );

  return getIconColorByStatus(!hasStatus0 ? 1 : 0);
}

export function generateMarkerPollutionRoseD3(data, tag, value, calm) {
  function serializeXmlNode(xmlNode) {
    if (typeof window.XMLSerializer != "undefined") {
      return (new window.XMLSerializer()).serializeToString(xmlNode);
    } else if (typeof xmlNode.xml != "undefined") {
      return xmlNode.xml;
    }
    return "";
  }

  let innerRadius = 25;
  let svg2 = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
  let decimalFixed = (tag && (tag.includes("(ppm)") || tag.includes("(mg/m3)"))) ? 2 : 1;

  if (!Array.isArray(data) || data.length === 0 || value === undefined || value === 0) {
    let svg = d3.select(svg2);
    svg2.setAttribute("viewBox", "0 0 70 70");
    svg2.setAttribute("preserveAspectRatio", "xMidYMid meet");
    svg2.style.width = "100%";
    svg2.style.height = "100%";

    let width = 50;
    let height = 50;
    let g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
    g.append("circle").attr("r", innerRadius).attr("fill", "rgba(0,0,0,0.7)");
    g.append("text")
      .attr("text-anchor", "middle").attr("font-family", "Manrope")
      .attr('font-size', '12px').attr('font-weight', 'bold')
      .attr('fill', 'white').attr('y', 5)
      .text(value === undefined ? "-" : parseFloat(value).toFixed(decimalFixed));

    return new L.DivIcon({
      html: serializeXmlNode(svg2),
      iconSize: [25, 25],
      iconAnchor: [12, 12],
      popupAnchor: [0, -25]
    });
  }

  let svg = d3.select(svg2);
  svg2.setAttribute("viewBox", "-20 -30 240 260");
  svg2.setAttribute("preserveAspectRatio", "xMidYMid meet");
  svg2.style.width = "100%";
  svg2.style.height = "100%";

  let width = 200;
  let height = 200;
  let outerRadius = Math.min(width, height) / 2;
  let g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
  let x = d3.scaleBand().range([0, 2 * Math.PI]).align(0);
  let y = d3.scaleRadial().range([innerRadius, outerRadius]);
  let colors = [];
  data.slice().reverse().forEach(d => colors.push(d.color));
  let z = d3.scaleOrdinal().range(colors);

  let dataObj = {
    "N": {}, "NNE": {}, "ENE": {}, "E": {}, "ESE": {}, "SSE": {}, "S": {}, "SSW": {}, "WSW": {}, "W": {}, "WNW": {}, "NNW": {}
  };
  Object.keys(dataObj).forEach(k => {
    dataObj[k].km = k;
    dataObj[k].total = 0;
  });

  let domains = [];
  data.forEach(d => {
    let nameValue = d.name;
    domains.push(nameValue);
    d.data.forEach(({ name, value }) => {
      if (!dataObj[name]) return;
      dataObj[name][nameValue] = value;
      dataObj[name]["total"] += value;
    });
  });

  let result = Object.values(dataObj);
  x.domain(result.map(d => d.km));
  y.domain([0, Math.max(5, d3.max(result, d => d.total))]);
  z.domain(domains);
  let angleOffset = -360.0 / result.length / 2.0;

  g.append("circle").attr("r", outerRadius).attr("fill", "rgba(255,255,255,0.6)");
  g.append("circle").attr("r", innerRadius).attr("fill", "rgba(0,0,0,0.7)");
  g.append("text")
    .attr("text-anchor", "middle").attr("font-family", "Manrope")
    .attr('font-size', '12px').attr('font-weight', 'bold')
    .attr('fill', 'white').attr('y', 5)
    .text(parseFloat(value).toFixed(decimalFixed));

  if (calm !== undefined) {
    g.append("rect").attr("width", 90).attr("height", 15)
      .attr('fill', 'rgba(255,255,255,0.6)').attr('y', 98).attr('x', -43);
    g.append("text")
      .attr("text-anchor", "middle").attr("font-family", "Manrope")
      .attr('font-size', '12px').attr('font-weight', 'bold')
      .attr('fill', 'black').attr('y', 110)
      .text("Calm " + parseFloat(calm).toFixed(decimalFixed) + " %");
  }

  g.append("g").selectAll("g").data(d3.stack().keys(domains)(result))
    .enter().append("g").attr("fill", d => z(d.key))
    .selectAll("path").data(d => d)
    .enter().append("path")
    .attr("d", d3.arc()
      .innerRadius(d => y(d[0]))
      .outerRadius(d => y(d[1]))
      .startAngle(d => x(d.data.km))
      .endAngle(d => x(d.data.km) + x.bandwidth())
      .padAngle(0.1).padRadius(innerRadius))
    .attr("transform", `rotate(${angleOffset})`);

  let yAxis = g.append("g").attr("text-anchor", "middle");
  let yTick = yAxis.selectAll("g").data(y.ticks(3).slice(1)).enter().append("g");
  yTick.append("circle").attr("fill", "none").attr("stroke", "#555555").attr("stroke-dasharray", "4,4").attr("r", y);
  yTick.append("text")
    .attr("y", d => -y(d)).attr("dy", "-0.15em").attr("x", 0)
    .text(d => d + " %")
    .style('fill', 'black').style("font-size", 10);

  const keys = Object.keys(dataObj);
  const numDirs = keys.length;
  const labelRadius = outerRadius + 18;
  const centerAngle = -Math.PI / 2;

  keys.forEach((key, i) => {
    const angle = (i / numDirs) * 2 * Math.PI + centerAngle;
    const x = Math.cos(angle) * labelRadius;
    const y = Math.sin(angle) * labelRadius + 5;
    g.append("text")
      .attr("x", x)
      .attr("y", y)
      .attr("text-anchor", "middle")
      .attr("alignment-baseline", "middle")
      .attr("font-family", "Manrope")
      .attr("font-size", "10px")
      .attr("font-weight", "bold")
      .attr("fill", "#222")
      .text(key);
  });

  return new L.DivIcon({
    html: serializeXmlNode(svg2),
    iconSize: [200, 200],
    iconAnchor: [100, 100],
    popupAnchor: [0, -100]
  });
}

export function generateMapRoseIcon(data, tag, value, calm) {
  return generateMarkerPollutionRoseD3(data, tag, value, calm)
}

export function createEmissionPointIcon(mode = "normal") {
  const isSelected = mode === "selected";
  const isActive = mode === "active";

  const size = isActive ? 18 : isSelected ? 15 : 12;

  const color =
    isActive ? "#005199" :
    isSelected ? "#ff2d2d" :
    "#7a0403";

  return L.divIcon({
    className: "",
    html: `
      <div style="position:relative; width:${size}px; height:${size}px;">
        
        ${isActive ? `
          <div style="
            position:absolute;
            width:${size + 8}px;
            height:${size + 8}px;
            border-radius:50%;
            background:rgba(0,81,153,0.25);
            top:-4px;
            left:-4px;
          "></div>
        ` : ""}

        <div style="
          width:${size}px;
          height:${size}px;
          background:${color};
          border:2px solid white;
          box-shadow:0 0 4px rgba(0,0,0,0.4);
          transition: all .2s ease;
        "></div>
      </div>
    `,
    iconSize: [size, size],
    iconAnchor: [size/2, size/2]
  });
}
